export default "__VITE_ASSET__Dj200_$Y__"